import { Badge, Space } from "antd";
import { currencyBRL, realParaNumber } from "./dinheiroBRAuxiliar";
import { CheckCircleOutlined, ExclamationCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";

export const somaValores = (listaAnexo: any) => {
  let soma = 0;
  listaAnexo.forEach((conta: any) => (soma += realParaNumber(conta.valor)));
  return soma;
};

export const CustomHeader = ({ texto, valor, listaAnexo }: any) => {
  const renderBadge = () => (
    <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {texto}
        <Badge
          color="#000000"
          style={{
            marginLeft: "4px",
            marginRight: "4px",
          }}
        />
        <p style={{ fontWeight: "700", marginBottom: "0px" }}>{currencyBRL(valor)}</p>
      </div>
      <div>
        {somaValores(listaAnexo) < valor ? (
          <ExclamationCircleOutlined style={{ fontSize: "18px", color: "#FAAD14" }} />
        ) : somaValores(listaAnexo) > valor ? (
          <CheckCircleOutlined style={{ fontSize: "18px", color: "#FAAD14" }} />
        ) : (
          ""
        )}
      </div>
    </Space>
  );

  return <>{renderBadge()}</>;
};

export const CustomHeaderLancamentoConsignatario = ({ texto }: any) => {
  const renderBadge = () => (
    <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {texto}
      </div>
    </Space>
  );

  return <>{renderBadge()}</>;
};
